import React, { useState, useEffect } from 'react'
import { MessageSeverity } from 'constants/message'
import IcoInfo from 'resources/images/app/ico_info.png'
import IcoWarning from 'resources/images/app/ico_warning.png'
import IcoSuccess from 'resources/images/app/ico_success.png'
import IcoError from 'resources/images/app/ico_error.png'
import './messageBlock.css'

/**
 * A Message block is a block showing a message along with a criticity icon (info, warning, error, success)
 * @param {*} props
 * @returns
 */
const MessageBlock = (props) => {
  const message = props.message
  const [icon, setIcon] = useState(IcoInfo)
  const [content, setContent] = useState('')

  useEffect(() => {
    // Severity
    if (message) {
      switch (message.level.toLowerCase()) {
        case MessageSeverity.WARNING:
          setIcon(IcoWarning)
          break
        case MessageSeverity.SUCCESS:
          setIcon(IcoSuccess)
          break
        case MessageSeverity.ERROR:
          setIcon(IcoError)
          break
        default:
          setIcon(IcoInfo)
          break
      }
    }

    setContent(message.content)
  }, [message])

  return (
    <div className='messageBlock'>
      <div className='severity'>
        <img src={icon} title='message severity' alt='message severity' />
      </div>
      <div>{content}</div>
    </div>
  )
}

export default MessageBlock
